import { ChangeDetectorRef, Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators, AbstractControl, ValidationErrors } from '@angular/forms';
import { ProformaRepository } from 'src/app/proforma/domain/proforma.repository';
import { ComercialRepository } from 'src/app/repositorio/comercial.repository';
import { Parametros } from 'src/app/services/domain/services-domain';
import { StorageService } from 'src/app/services/storage.service';
import { UtilService } from 'src/app/services/util.service';
import { newmetadate } from 'src/app/shared/components/datatable/domain/datatable-domain';
import { ConsultarDireccionEntidadRequest, consultarServiciosRequest, ListarArchivoEntidadRequest, ListarAuditoriaRequest, ListarCuentasBancariasRequest, ListarEntidadesRequest, ListarHistorialRequest, ListarLimiteCreditoRequest, ListarUbigeosRequest, SincronizarEntidadSapRequest, TablaDireccionEntidad, TablaEntidadBloqueo, TablaEntidadRelacionados, TransaccionEntidadBloqueoRequest, TransaccionEntidadRelacionadosRequest, ValidarDocIdentidadRequest, TablaEntidadServicios, envioCorreosRequest, formatoCorreoRequest, registroNuevoRucRequest, itemsConfirmarRuc, envioFinanzasNuevoClienteRequest } from '../../../domain/request/mantenimiento-request';
import { SelectItem } from 'primeng/api/selectitem';
import { MessageService } from 'primeng/api';
import { lisPais, listDepartamento, listProvincia, listDistrito } from 'src/app/proforma/domain/response/proforma_response';
import { requestDepartamento, requestProvincia, requestDistrito, incoterRequest, sunatRequest } from 'src/app/proforma/domain/request/proforma_request';
import { ListaCuentasBancarias, ListarEntidades } from '../../../domain/response/mantenimiento-response';
import { ComisionesRepository } from 'src/app/comisiones/domain/Comisiones-repository';
import { ListarTiposRequest } from 'src/app/statement-carrier/domain/request/statement-carrier-request';
import { error } from 'pdf-lib';
import { Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { firstValueFrom } from 'rxjs';
import { SelectedItems } from 'src/app/services/SelectedItems';
import { DatatableComponent } from 'src/app/shared/components/datatable/datatable.component';

@Component({
  selector: 'app-page-mant-clientes',
  templateUrl: './page-mant-clientes.component.html',
  styleUrls: ['./page-mant-clientes.component.css'],
  providers: [MessageService],
  standalone: false
})

export class PageMantClientesComponent {
  constructor(private readonly mantcomercial: ComercialRepository,
    private readonly storage: StorageService,
    private util: UtilService,
    private readonly comisiones: ComisionesRepository,
    private readonly proformaService: ProformaRepository,
    private messageService: MessageService,
    private readonly router: Router,
    private readonly title: Title,
    private cdr: ChangeDetectorRef,
  ) { }

  fechaActual: Date = new Date();
  codigoEntidad: number = 1
  //FORMULARIOS PARA CADA SECCION
  group: FormGroup
  groupPoppupDG: FormGroup
  groupPoppupD: FormGroup
  groupPoppupB: FormGroup
  groupPS: FormGroup
  groupPoppupE: FormGroup
  //DATATABLES
  dataTable: any[] = []
  dataTableCuentasBancarias: any[] = []
  dataTableServicios: any[] = []
  dtS: any[] = []
  // inicializar y enviar los valores manualmente
  defaultRowCuentasBancarias: ListaCuentasBancarias = {
    tipotran: null,
    entC_Codigo: null,
    tipO_TabBCO: null,
    tipO_CodBCO: null,
    tipO_BCO: null,
    encB_TipoCuenta: null,
    tipoCuenta: null,
    encB_NroCuentaSol: null,
    encB_NroCuentaDol: null,
  };

  defaultRowServicios: any = {
    servicio: null,
    valor: null,
    fechainicio: null,
    fechaventa: null,
    tipoacuerdo: null,
    beneficiario: null,
    notas: null,
    eseR_Cantidad: 0,
    // eseR_Codigo: 0,
    eseR_Exonerado: false,
    eseR_Valor: 0,
  }

  defaultRowRelacionados: TablaEntidadRelacionados = {
    entC_CodPadre: null, entC_CodHijo: null, conS_TabRGM: "RGM", conS_CodRGM: null,
    relA_Activo: null, tipO_TabTRF: "TRF", tipO_CodTRF: null, relA_Tipos: null,
    relA_DepTemNegociaAgente: null, tipE_CodPadre: null, tipE_CodHijo: null,
    audI_UsrCrea: null, audI_UsrMod: null
  };

  dataTableLimiteCredito: any[] = []
  InsertLimCredito: any[] = []
  dataTableAuditoria: any[] = []
  dataTableArchivos: any[] = []
  dataTableDireccion: any[] = []
  dataTableHistorial: any[] = []
  dataTableAuditoriaServicios: any[] = []
  dataTableRelacionados: any[] = []
  //CONDICIONES
  visible: boolean
  juridica: boolean
  natural: boolean
  visiblebtn: boolean
  visiblenumdoc: boolean = true
  estadoEditar: boolean = true;
  //LISTAS DROPDOWN
  ListaTodosTipoDoc: any[] = []
  ListaTodosBanco: SelectItem[] = []
  ListaTodosMoneda: SelectItem[] = []
  ListarTodosSegmento: any[] = []
  ListaMonedaDP: SelectedItems[] = []
  ListaBaseDP: SelectedItems[] = []
  ListaServiciosDP: SelectedItems[] = []
  ListaTodosTipoEntidad: any[] = []
  ListaTodosTipoAcuerdo: any[] = []
  ListaRegimenDP: SelectItem[] = []
  ListaTraficoDP: SelectItem[] = []
  ListaLineaNegocioDP: SelectItem[] = []
  ListaViaDP: SelectItem[] = []
  ListaTipoEntidadDP: SelectedItems[] = []
  ListaTipoRelacionDP: SelectedItems[] = []
  ListaNombreEntidadesDP: SelectedItems[] = []
  ListaFiltradaNombreEntidadesDP: SelectedItems[] = []
  ListaFiltradaTipoEntidadDP: SelectedItems[] = []
  listaDatosEntidad: any = [];
  tipo: any[] = []
  sexo: any[] = []
  atributos: any[] = []
  tipocuenta: SelectItem[] = []
  formapago: SelectItem[] = []
  listPais: lisPais[] = [];
  listDepartamento: any[] = [];
  listProvincia: any[] = [];
  listDistrito: any[] = [];
  activeIndex: number
  activeIndex2: number
  entcCod: number
  nomUsuario = '';
  correoUsuario = '';

  // emit para enviar datos al datatable
  @Output() onDpChangeTblServicios: EventEmitter<any> = new EventEmitter();
  @Output() onDpChangeTblRelacionados: EventEmitter<any> = new EventEmitter();

  metadataTable: newmetadate[] = [
    { title: 'Sincronizar SAP', field: '', inputType: 'buttonPersonalizado', icon: 'pi pi-user', loading: false, function: (row: any) => this.sincronizarSAP(row), style: { align: "center" } },
    { field: 'entC_Codigo', title: 'Código', inputType: 'text' }, { field: 'tipO_CodTDI', title: 'Tipo Doc. Iden.', inputType: 'text' },
    { field: 'entC_DocIden', title: 'N.I.T', inputType: 'text' }, { field: 'entC_RazonSocial', title: 'Nombre', inputType: 'text' },
    { field: 'entC_Activo', title: 'Activo', inputType: 'checkbox' }, { field: 'entC_EMail', title: 'Correo', inputType: 'text' },
    { field: 'entC_EmailReceptorFE', title: 'Correo Factura Electrónica', inputType: 'text' }, { field: 'entC_Telef1', title: 'Tel. Fijo', inputType: 'text' },
    { field: 'entC_Telef2', title: 'Tel. Móvil', inputType: 'text' }, { field: 'entC_CodSAP_C', title: 'Cliente SAP', inputType: 'text' },
    { field: 'entC_CodSAP_P', title: 'Proveedor SAP', inputType: 'text' }, { field: 'entC_FecActSAP', title: 'Sincronización SAP', inputType: 'datetime' },
    { field: 'audI_UsrCrea', title: 'Creado por', inputType: 'text' }, { field: 'audI_FecCrea', title: 'Fecha crea', inputType: 'datetime' },
    { field: 'audI_UsrMod', title: 'Modificado por', inputType: 'text' }, { field: 'audI_FecMod', title: 'Fecha mod.', inputType: 'datetime' }
  ]

  metadataTableCuentasBancarias: newmetadate[] = [
    { field: 'tipO_BCO', title: 'Banco', inputType: 'autocomplete', dropdown: this.ListaTodosBanco }, { field: 'tipoCuenta', title: 'Tipo de Cuenta', inputType: 'autocomplete', dropdown: this.tipocuenta },
    { field: 'encB_NroCuentaSol', title: 'Cuenta en S/.', inputType: 'text' }, { field: 'encB_NroCuentaDol', title: 'Cuenta en US$', inputType: 'text' }
  ]

  mdtS: newmetadate[] = [
    { field: 'nombre', title: 'Nombre del Servicio', inputType: 'text', filterType: 'text' },
    { field: 'critico', title: 'Critico', inputType: 'checkboxEdit' }
  ]

  metadataTableAuditoria: newmetadate[] = [
    { field: 'operacion', title: 'Operación', inputType: 'text' }, { field: 'direccionip', title: 'Dirección IP', inputType: 'text' },
    { field: 'nombremaquina', title: 'Nombre Máquina', inputType: 'text' }, { field: 'nombreaplicacion', title: 'Nombre Aplicación', inputType: 'text' },
    { field: 'usuariosql', title: 'Usuario SQL', inputType: 'text' }, { field: 'usuarioaplicacion', title: 'Usuario Aplicación', inputType: 'text' },
    { field: 'fechamodificacion', title: 'Fecha Modificación', inputType: 'datetime' }, { field: 'codigoentidad', title: 'Código Entidad', inputType: 'text' },
    { field: 'docidentidad', title: 'Doc. Identidad', inputType: 'text' }, { field: 'codigodocidentidad', title: 'Código Doc. Iden.', inputType: 'text' },
    { field: 'numdocidentidad', title: 'Num. Doc. Identidad', inputType: 'text' }, { field: 'tipopersona', title: 'Tipo Persona', inputType: 'text' },
    { field: 'domiciliado', title: 'Domiciliado', inputType: 'checkbox' }, { field: 'nombres', title: 'Nombres', inputType: 'text' },
    { field: 'apellidopaterno', title: 'Ape. Paterno', inputType: 'text' }, { field: 'apellidomaterno', title: 'Ape. Materno', inputType: 'text' },
    { field: 'nombrecompleto', title: 'Nom. Completo', inputType: 'text' }, { field: 'nombrecomercial', title: 'Nom. Comercial', inputType: 'text' },
    { field: 'razonsocial', title: 'Razón Social', inputType: 'text' }, { field: 'activo', title: 'Activo', inputType: 'checkbox' },
    { field: 'fechanacimiento', title: 'Fec. Nacimiento', inputType: 'datetime' }, { field: 'fechaingreso', title: 'Fec. Ingreso', inputType: 'datetime' },
    { field: 'vip', title: 'VIP', inputType: 'checkbox' }, { field: 'notas', title: 'Notas', inputType: 'text' },
    { field: 'sexo', title: 'Sexo', inputType: 'text' }, { field: 'email', title: 'E-mail', inputType: 'text' },
    { field: 'email2', title: 'E-mail2', inputType: 'text' }, { field: 'web', title: 'Web', inputType: 'text' },
    { field: 'propio', title: 'Propio', inputType: 'checkbox' }, { field: 'telefono1', title: 'Teléfono 1', inputType: 'text' },
    { field: 'telefono2', title: 'Teléfono 2', inputType: 'text' }, { field: 'telefono3', title: 'Teléfono 3', inputType: 'text' },
    { field: 'telefono4', title: 'Teléfono 4', inputType: 'text' }, { field: 'beneficiario', title: 'Beneficiario', inputType: 'text' },
    { field: 'area', title: 'Área', inputType: 'text' }, { field: 'cargo', title: 'Cargo', inputType: 'text' },
    { field: 'cuentausuario', title: 'Cuenta Usuario', inputType: 'text' }, { field: 'pais', title: 'País', inputType: 'text' },
    { field: 'codigopais', title: 'Cod. País', inputType: 'text' }, { field: 'holding', title: 'Holding', inputType: 'text' },
    { field: 'codigoholding', title: 'Cod. Holding', inputType: 'text' }, { field: 'tipotarifa', title: 'Tipo Tarifa', inputType: 'text' },
    { field: 'codigotarifa', title: 'Cod. Tarifa', inputType: 'text' }, { field: 'prospecto', title: 'Prospecto', inputType: 'checkbox' },
    { field: 'rebate', title: 'Rebate', inputType: 'decimal' }, { field: 'moneda', title: 'Moneda', inputType: 'text' },
    { field: 'codigomoneda', title: 'Cod. Moneda', inputType: 'text' }, { field: 'tipodeposito', title: 'Tipo Depósito', inputType: 'text' },
    { field: 'codtipodeposito', title: 'Cod. Tipo Depósito', inputType: 'text' }, { field: 'tarja', title: 'Tarja', inputType: 'decimal' },
    { field: 'realizatarja', title: 'Realiza Tarja', inputType: 'checkbox' }, { field: 'diacredito', title: 'Día Crédito', inputType: 'int' },
    { field: 'fechacredito', title: 'Fec. Crédito', inputType: 'datetime' }, { field: 'codigoaduana', title: 'Cod. Aduana', inputType: 'text' },
    { field: 'observaciones', title: 'Observaciones', inputType: 'text' }, { field: 'cuenintersoles', title: 'Cuen. Inter. Soles', inputType: 'text' },
    { field: 'cueninterdolares', title: 'Cuen. Inter. Dólares', inputType: 'text' }, { field: 'cuendetraccion', title: 'Cuen. Detracción', inputType: 'text' },
    { field: 'serviciologistico', title: 'Servicio Logístico', inputType: 'checkbox' }, { field: 'ocultarshipper', title: 'Ocultar Shipper', inputType: 'checkbox' },
    { field: 'obserfinanzas', title: 'Obser. Finanzas', inputType: 'text' }, { field: 'otrostraficos', title: 'Otros Tráficos', inputType: 'checkbox' },
    { field: 'mandato', title: 'Mandato', inputType: 'checkbox' }, { field: 'sli', title: 'SLI', inputType: 'checkbox' },
    { field: 'exportacion', title: 'Exportación', inputType: 'checkbox' }, { field: 'emailfinanzas', title: 'E-mail Fnanzas', inputType: 'text' },
    { field: 'bloqueocliente', title: 'Bloqueo Cliente', inputType: 'text' }, { field: 'usubloqueacliente', title: 'Usu Bloquea Cliente', inputType: 'text' },
    { field: 'fecbloqueocliente', title: 'Fec. Bloqueo Cliente', inputType: 'datetime' }, { field: 'obserbloqueocliente', title: 'Obser. Bloqueo Cliente', inputType: 'text' },
    { field: 'bloqueoproveedor', title: 'Bloqueo Proveedor', inputType: 'checkbox' }, { field: 'usubloqueaproveedor', title: 'Usu. Bloquea Proveedor', inputType: 'text' },
    { field: 'fecbloqueoproveedor', title: 'Fec. Bloqueo Proveedor', inputType: 'datetime' }, { field: 'obserbloqueoproveedor', title: 'Obser. Bloqueo Proveedor', inputType: 'text' },
    { field: 'obserproveedor', title: 'Obser. Proveedor', inputType: 'text' }, { field: 'asumedetraccion', title: 'Asume Detracción', inputType: 'checkbox' },
    { field: 'usuariocrea', title: 'Usuario Crea', inputType: 'text' }, { field: 'fechacrea', title: 'Fecha Crea', inputType: 'datetime' },
    { field: 'usuariomodifica', title: 'Usuario Modifica', inputType: 'text' }, { field: 'fechamodifica', title: 'Fecha Modifica', inputType: 'datetime' }
  ]

  metadataTableLimiteCredito: newmetadate[] = [
    { field: 'tipO_MND', title: 'Moneda', inputType: 'autocomplete', dropdown: this.ListaTodosMoneda }, { field: 'enlI_Monto', title: 'Monto', inputType: 'int' },
    { field: 'enlI_FecInicio', title: 'Fecha Inicio', inputType: 'date' }, { field: 'enlI_FecVencimiento', title: 'FechaVencimiento', inputType: 'date' },
    { field: 'enlI_FormaPagoDescripcion', title: 'Forma Pago', inputType: 'autocomplete', dropdown: this.formapago }, { field: 'enlI_Notas', title: 'Notas', inputType: 'textOnlyInput' },
  ]

  metadataTableHistorial: newmetadate[] = [
    { field: 'enlI_Codigo', title: 'Código', inputType: 'text' }, { field: 'tipO_MND', title: 'Moneda', inputType: 'text' },
    { field: 'enlI_Monto', title: 'Monto', inputType: 'decimal' }, { field: 'enlI_Fecha', title: 'Fecha Convenio', inputType: 'date' },
    { field: 'enlI_DiasDuracion', title: 'Dias', inputType: 'int' }
  ]

  metadataTableRelacionados: newmetadate[] = [
    { field: 'relA_TipoRelacion', title: 'Tipo Relación', inputType: 'autocomplete', dropdown: this.ListaTipoRelacionDP, required: true },
    { field: 'conS_RGM', title: 'Régimen', inputType: 'autocomplete', dropdown: this.ListaRegimenDP },
    { field: 'tipE_Hijo', title: 'Tipo Entidad', inputType: 'autocomplete', dropdown: this.ListaTipoEntidadDP, required: true },
    { field: 'entC_RazonSocial', title: 'Razón Social/Nombres', inputType: 'autocomplete', dropdown: this.ListaNombreEntidadesDP, required: true },
    { field: 'entC_CodHijo', title: 'Código', inputType: 'textdisabled', required: true },
    { field: 'entC_DocIden', title: 'Número Documento', inputType: 'textdisabled' },
    { field: 'tipO_TRF', title: 'TRF', inputType: 'autocomplete', dropdown: this.ListaTraficoDP, required: true },
    { field: 'entC_EMail', title: 'E-mail', inputType: 'textdisabled' },
    { field: 'entC_EmailReceptorFE', title: 'E-mail FE', inputType: 'textdisabled' },
    { field: 'audI_FecCrea', title: 'Creación', inputType: 'dateDisabled' },
    { field: 'audI_FecMod', title: 'Actualización', inputType: 'dateDisabled' },
    { field: 'relA_Observacion', title: 'Observaciones', inputType: 'text' }
  ]

  metadataTableServicios: newmetadate[] = [
    { field: 'key', title: 'Código', inputType: 'textdisabled' },
    { field: 'serV_Nombre', title: 'Servicio', inputType: 'autocomplete', dropdown: this.ListaServiciosDP, required: true },
    { field: 'tipO_DescMND', title: 'Moneda', inputType: 'autocomplete', dropdown: this.ListaMonedaDP, required: true },
    { field: 'eseR_Valor', title: 'Valor', inputType: 'decimal', required: true },
    { field: 'conS_DescBAS', title: 'Aplicado/Base de Cálculo', inputType: 'autocomplete', dropdown: this.ListaBaseDP },
    { field: 'eseR_Exonerado', title: 'Exonerado', inputType: 'checkboxEdit' },
    { field: 'conS_DescLNG', title: 'Línea', inputType: 'autocomplete', dropdown: this.ListaLineaNegocioDP, inputStatus: 'lock', showClear: false },
    { field: 'conS_DescRGM', title: 'Régimen', inputType: 'autocomplete', dropdown: this.ListaRegimenDP, inputStatus: 'lock', showClear: false },
    { field: 'conS_DescVIA', title: 'Vía', inputType: 'autocomplete', dropdown: this.ListaViaDP, inputStatus: 'lock', showClear: false },
  ]

  metadataTableAuditoriaServicios: newmetadate[] = [
    { field: 'operacion', title: 'Operación', inputType: 'text' },
    { field: 'direccion_IP', title: 'Dirección IP', inputType: 'text' },
    { field: 'nombre_Maquina', title: 'Nombre máquina', inputType: 'text' },
    { field: 'nombre_Aplicacion', title: 'Nombre Aplicación', inputType: 'text' },
    { field: 'usuario_SQL', title: 'Usuario SQL', inputType: 'text' },
    { field: 'usuario_Aplicacion', title: 'Usuario Aplicación', inputType: 'text' },
    { field: 'fecha_Modificacion', title: 'Fecha Modificación', inputType: 'date' },
    { field: 'codigo_Interno', title: 'Código Interno', inputType: 'text' },
    { field: 'cod_Servicio', title: 'Cod Servicio', inputType: 'text' },
    { field: 'cod_Entidad', title: 'Cod Entidad', inputType: 'text' },
    { field: 'valor', title: 'Valor', inputType: 'text' },
    { field: 'exonerado', title: 'Exonerado', inputType: 'checkboxEdit' },
    { field: 'cantidad', title: 'Cantidad', inputType: 'text' },
    { field: 'moneda', title: 'Moneda', inputType: 'text' },
    { field: 'cod_Moneda', title: 'Cod Moneda', inputType: 'text' },
    { field: 'base_Calculo', title: 'Base Cálculo', inputType: 'text' },
    { field: 'cod_Base_Calculo', title: 'Cod Base Cálculo', inputType: 'text' },
    { field: 'usuario_Crea', title: 'Usuario Crea', inputType: 'text' },
    { field: 'fec_Crea', title: 'Fec Crea', inputType: 'date' },
    { field: 'usuario_Modifica', title: 'Usuario Modifica', inputType: 'text' },
    { field: 'fec_Modifica', title: 'Fec Modifica', inputType: 'date' },
  ]

  customAuditoriaServicios = [
    { icon: 'pi pi-file-export', function: () => this.exportarAuditoriaServicios(), toolTip: "Exportar Excel" }
  ];

  parametros: Parametros[] = []
  async ListarParametros() {
    this.parametros = await this.util.getParametros()
    this.tipo = [{ name: 'Jurídica', key: 'J' }, { name: 'Natural', key: 'N' }];
    this.sexo = [{ name: 'Femenino', key: 'F' }, { name: 'Masculino', key: 'M' }];
    this.ListaTodosTipoDoc = this.parametros.slice().filter(r => r.tipo === 'TIPODOC')
    this.listPais = this.parametros.slice().filter(r => r.tipo === 'PAI')
    this.ListarTodosSegmento = this.parametros.slice().filter(r => r.tipo === 'SEGMENTO')
    this.ListaTodosTipoEntidad = this.parametros.slice().filter(r => r.tipo === 'TIPE')
    this.ListaTodosTipoAcuerdo = this.parametros.slice().filter(r => r.tipo === 'ACU')
    this.parametros.map(r => {
      if (r.tipo === 'BANCO') {
        const item: SelectItem = {
          label: r.nombre, value: r.codigo
        }
        this.ListaTodosBanco.push(item)
      }
      if (r.tipo === 'MONEDA') {
        const item: SelectItem = {
          label: r.adicional1, value: r.codigo
        }
        this.ListaTodosMoneda.push(item)
      }
      if (r.tipo === 'BAS') {
        const item: SelectItem = {
          label: r.nombre, value: r.codigo
        }
        this.ListaBaseDP.push(item)
      }
      if (r.tipo === 'SERVICIO') {
        const item: SelectItem = {
          label: r.nombre, value: r.codigo
        }
        this.ListaServiciosDP.push(item)
      }
      if (r.tipo === 'MND') {
        const item: SelectItem = {
          label: r.nombre, value: r.codigo
        }
        this.ListaMonedaDP.push(item)
      }
      if (r.tipo === 'TIPO_ENTIDAD') {
        const item = { label: r.nombre, value: r.codigo }
        this.ListaTipoEntidadDP.push(item)
      }
      if (r.tipo === 'RELA_TIPOS') {
        const item = { label: r.nombre, value: r.codigo, key: r.adicional1 }
        this.ListaTipoRelacionDP.push(item)
      }
      if (r.tipo === 'AGE' || r.tipo === 'CONTACTO' || r.tipo === 'CUS' || r.tipo === 'DepositoVacio'
        || r.tipo === 'DepositoTemp' || r.tipo === 'EJEC' || r.tipo === 'TRANSPORTISTA') {
        const item = { label: r.nombre, value: r.codigo, tipo: r.tipo }
        this.ListaNombreEntidadesDP.push(item)
      }
      if (r.tipo === 'RGM') {
        const item = { label: r.nombre, value: r.codigo }
        this.ListaRegimenDP.push(item)
      }
      if (r.tipo === 'TRF') {
        const item = { label: r.nombre, value: r.codigo }
        this.ListaTraficoDP.push(item)
      }
      if (r.tipo === 'LNG') {
        const item = { label: r.nombre, value: r.codigo }
        this.ListaLineaNegocioDP.push(item)
      }
      if (r.tipo === 'VIA') {
        const item = { label: r.nombre, value: r.codigo }
        this.ListaViaDP.push(item)
      }
    })
    let tipo: SelectItem[] = [{ label: 'CUENTA CORRIENTE', value: 'C' }, { label: 'CUENTA DE AHORROS', value: 'A' }, { label: 'CUENTA MAESTRA', value: 'M' }];
    this.tipocuenta.push(...tipo)
    let formap: SelectItem[] = [{ label: 'CHEQUE DIFERIDO', value: 'C' }, { label: 'CONTRA DOCUMENTO', value: 'D' }];
    this.formapago.push(...formap)
    this.ListaFiltradaNombreEntidadesDP = this.ListaNombreEntidadesDP
    this.ListaFiltradaTipoEntidadDP = this.ListaTipoEntidadDP

    this.cdr.markForCheck()
  }

  async ngOnInit(): Promise<void> {
    this.fechaActual = new Date();
    this.nomUsuario = this.storage.get('usuario');
    this.correoUsuario = this.storage.get('correo');
    this.groupPoppupDG = new FormGroup({
      codigo: new FormControl(null, null), activo: new FormControl(null, null),
      tipopersona: new FormControl("J", null), tipodocumento: new FormControl(null, null),
      numerodocumento: new FormControl(null, null), razonsocial: new FormControl(null, null),
      razoncomercial: new FormControl(null, null), nomgerente: new FormControl(null, null),
      fechanacimientog: new FormControl(null, null), fechaAniversariog: new FormControl(null, null),
      apellidopaterno: new FormControl(null, null), apellidomaterno: new FormControl(null, null),
      nombres: new FormControl(null, null), sexo: new FormControl(null, null),
      area: new FormControl(null, null), cargo: new FormControl(null, null),
      fechanacimiento: new FormControl(null, null), fechaingreso: new FormControl(null, null),
      correo: new FormControl(null, this.multiEmailTrimmedValidator), contactonombre: new FormControl(null, null),
      contactoapellidos: new FormControl(null, null), correoexport: new FormControl(null, this.multiEmailTrimmedValidator),
      direccion: new FormControl(null, null), pais: new FormControl(null, null),
      departamento: new FormControl(null, null), provincia: new FormControl(null, null),
      distrito: new FormControl(null, null), atributosadic: new FormControl(null, null),
      fechacredito: new FormControl(null, null), diascreditos: new FormControl(null, null),
      observaciones: new FormControl(null, null), nodomiciliado: new FormControl(null, null),
      vip: new FormControl(null, null), prospecto: new FormControl(null, null),
      serviciologistico: new FormControl(null, null), correo_otros_traficos: new FormControl(null, this.multiEmailTrimmedValidator),
      correo_facturacion: new FormControl(null, this.multiEmailTrimmedValidator), telefono_fijo: new FormControl(null, null),
      telefono_movil: new FormControl(null, null),
      informar_facturacion: new FormControl(null, null)
    })
    this.groupPoppupD = new FormGroup({
      correofinanzas: new FormControl(null, this.multiEmailTrimmedValidator), ctaintersoles: new FormControl(null, null),
      ctainterdolares: new FormControl(null, null), ctadetracciones: new FormControl(null, null),
      asumedetraccion: new FormControl(null, null),
      esMandato: new FormControl(null, null), esOtrosTraficos: new FormControl(null, null),
      esSli: new FormControl(null, null), esExportaciones: new FormControl(null, null)
    })
    this.groupPoppupB = new FormGroup({
      bloqueado: new FormControl(null, null), usuariobloqueo: new FormControl(null, null),
      fechabloqueoo: new FormControl(null, null), comentariobloqueo: new FormControl(null, null),
    })
    this.group = new FormGroup({
      numdocumento: new FormControl(null, null), razonsocial: new FormControl(null, null)
    })
    this.groupPS = new FormGroup({
      servicios: new FormControl(null, null),
    })
    this.groupPoppupE = new FormGroup({
      tipoentidad: new FormControl({ value: null, disabled: true }),
      numdocumento: new FormControl({ value: null, disabled: true }),
      razonsocial: new FormControl({ value: null, disabled: true })
    })
    this.ListarParametros()
  }

  search() {
    const loadingScreen = this.util.showLoadingScreen({ message: "Buscando datos ..." });
    const Request: ListarEntidadesRequest = <ListarEntidadesRequest>{}
    Request.pintENTC_Codigo = null
    Request.pvchENTC_NomCompleto = this.group.get('razonsocial').value;
    Request.pvchTIPE_Codigo = this.codigoEntidad;
    Request.pvchENTC_DocIden = this.group.get('numdocumento').value;
    this.dataTable = []
    this.mantcomercial.ListarEntidades(Request).subscribe(response => {
      if (response.datos.status === 200) {
        this.dataTable = response.datos.result;
        loadingScreen.close();
      } else {
        loadingScreen.close();
        this.dataTable = []
        this.util.ShowMessage({ titulo: "ERROR", mensaje: "No se encontraron datos", icono: "pi pi-exclamation-triangle", tipo: "warning" });
      }
    }, err => {
      loadingScreen.close();
      this.dataTable = []
      this.util.ShowMessage({ titulo: err.error?.meta?.mensaje, tipo: 'warning', icono: 'pi pi-exclamation-triangle' });
    })
  }

  validarDocumento() {
    const values = this.groupPoppupDG.value
    const Request: ValidarDocIdentidadRequest = <ValidarDocIdentidadRequest>{}
    Request.pintENTC_Codigo = 0
    Request.pchrTIPO_TabTDI = 'TDI'
    Request.pchrTIPO_CodTDI = values['tipodocumento']
    Request.pvchENTC_DocIden = values['numerodocumento']
    this.mantcomercial.ValidarEntidadSunat(Request).subscribe(response => {
      if (response.datos.status === 200) {
        this.editEntidad('', response.datos.result[0])
        this.messageService.clear();
        this.messageService.add({ key: 'toast1', severity: 'success', summary: 'OK', detail: 'Se cargó la información correctamente.' });
      }
    }, (errorServicio => {
      const requestSunat: sunatRequest = <sunatRequest>{}
      requestSunat.razonsocial = values["razonSocial"]
      requestSunat.ruc = values["numerodocumento"]

      this.proformaService.listarSunat(requestSunat).subscribe(response => {
        if (response.datos.result.length > 0) {
          const rawNombre = response.datos.result[0].nombre_o_razon_social || '';
          const nombre_o_razon_social = rawNombre.replace(/\\/g, '');
          this.groupPoppupDG.get('razonsocial').setValue(nombre_o_razon_social)
          this.groupPoppupDG.get('direccion').setValue(response.datos.result[0].direccion_completa)
          // asignar pais departamento distrito y provincia
          const ubigeo = response.datos.result[0].ubigeo;
          const ubigeoFormateado = ubigeo?.length === 6 ? ubigeo?.slice(0, 2) + '.' + ubigeo?.slice(2, 4) + '.' + ubigeo?.slice(4, 6) : ubigeo;
          const tipo_codpais = "179"; // peru por default
          const pai = this.listPais.find(r => r.codigo.toUpperCase() === tipo_codpais.toUpperCase())?.codigo
          this.groupPoppupDG.get('pais')?.setValue(pai);
          const partes = ubigeoFormateado?.split(".");
          const departamento = partes?.[0] ?? null;
          const provincia = partes?.[0] && partes?.[1] ? `${partes[0]}.${partes[1]}` : null;
          const distrito = ubigeoFormateado ?? null;
          this.onPaisSeleccionado(pai, 'INI')
          this.groupPoppupDG.get('departamento')?.setValue(departamento);
          this.onDepartamentoSeleccionado(departamento, 'INI')
          this.groupPoppupDG.get('provincia')?.setValue(provincia);
          this.onprovinciaSeleccionada(provincia, 'INI')
          this.groupPoppupDG.get('distrito')?.setValue(distrito);
          this.messageService.clear();
          this.messageService.add({ key: 'toast1', severity: 'success', summary: 'OK', detail: 'El documento de identidad se encuentra registrado en SUNAT.' });
        }
      }, (err => {
        this.messageService.clear();
        this.messageService.add({ key: 'toast2', severity: 'error', summary: 'Error', detail: 'El documento de identidad no se encuentra registrado en SUNAT, por favor verifique.' });
      }))
    }))
  }

  verInputs(event) {
    const values = this.groupPoppupDG.value
    if (event === 'J' || values.tipopersona === 'J') {
      this.juridica = true, this.natural = false
    } else if (event === 'N' || values.tipopersona === 'N') {
      this.juridica = false, this.natural = true
    }
  }

  onPaisSeleccionado(event: any, tipo: string) {
    let valor;
    if (tipo == 'EVE') {
      valor = event.value;
    } else if (tipo == 'INI') {
      valor = event;
    }
    if (valor != null) {
      const request: ListarUbigeosRequest = <ListarUbigeosRequest>{}
      request.pvchUBIG_Codigo = null
      request.pchrTIPO_CodPais = valor;
      request.pchrTIPO_TabPais = 'PAI'
      this.mantcomercial.ListarUbigeos(request).subscribe(response => {
        const departamento = response.datos.result.filter(item => item.ubiG_CodPadre === null);
        this.listDepartamento = departamento;
      },
        err => {
          this.listDepartamento = [];
          this.listProvincia = [];
          this.listDistrito = [];
        });
    } else {
      this.listDepartamento = [];
      this.listProvincia = [];
      this.listDistrito = [];
    }
  }
  onDepartamentoSeleccionado(event: any, tipo: string) {
    let valor;
    if (tipo == 'EVE') {
      valor = event.value;
    } else if (tipo == 'INI') {
      valor = event;
    }
    if (valor != null) {
      const departamentoSeleccionado = valor;
      const request: ListarUbigeosRequest = <ListarUbigeosRequest>{}
      request.pvchUBIG_Codigo = null
      request.pchrTIPO_CodPais = this.groupPoppupDG.get('pais').value;
      request.pchrTIPO_TabPais = 'PAI'
      this.mantcomercial.ListarUbigeos(request).subscribe(response => {
        const provincias = response.datos.result.filter(item => item.ubiG_CodPadre === departamentoSeleccionado);
        this.listProvincia = provincias;
      }, err => { this.listProvincia = []; });
    } else {
      this.listProvincia = [];
    }
  }
  onprovinciaSeleccionada(event: any, tipo: string) {
    let valor;
    if (tipo == 'EVE') {
      valor = event.value;
    } else if (tipo == 'INI') {
      valor = event;
    }
    if (valor != null) {
      const provinciaseleccionada = valor;
      const request: ListarUbigeosRequest = <ListarUbigeosRequest>{}
      request.pvchUBIG_Codigo = null
      request.pchrTIPO_CodPais = this.groupPoppupDG.get('pais').value;
      request.pchrTIPO_TabPais = 'PAI'
      this.mantcomercial.ListarUbigeos(request).subscribe(response => {
        const distritos = response.datos.result.filter(item => item.ubiG_CodPadre === provinciaseleccionada);
        this.listDistrito = distritos;
      },
        err => {
          this.listDistrito = [];
        });
    } else {
      this.listDistrito = [];
    }
  }

  nuevo() {
    this.estadoEditar = false;
    this.visible = true
    this.visiblebtn = true
    this.entcCod = 0
    this.groupPoppupDG.reset()
    this.groupPoppupD.reset()
    this.groupPoppupB.reset()
    this.groupPoppupE.reset()
    this.groupPoppupDG.get('tipopersona').setValue("J")
    this.dataTableCuentasBancarias = []
    this.dataTableServicios = []
    this.dataTableLimiteCredito = []
    this.dataTableAuditoria = []
    this.dataTableDireccion = []
    this.dataTableArchivos = []
    this.uploadedFiles = []
    this.dataTableRelacionados = [];
    this.dataTableServicios = []
    this.dataTableAuditoriaServicios = []
    this.listaDatosEntidad = [];
    this.groupPoppupDG.get('activo').setValue(true)
    this.groupPoppupDG.get('vip').setValue(false);
    this.groupPoppupDG.get('diascreditos').setValue(0);
    this.groupPoppupDG.get('nodomiciliado').setValue(false);
    this.groupPoppupDG.get('prospecto').setValue(false);
    this.groupPoppupDG.get('serviciologistico').setValue(false);
    this.groupPoppupD.get('esMandato').setValue(false);
    this.groupPoppupD.get('esOtrosTraficos').setValue(false);
    this.groupPoppupD.get('esSli').setValue(false);
    this.groupPoppupD.get('esExportaciones').setValue(false);
    this.groupPoppupD.get('esMandato').disable();
    this.groupPoppupD.get('esOtrosTraficos').disable();
    this.groupPoppupD.get('esSli').disable();
    this.groupPoppupD.get('esExportaciones').disable();
    this.cargarInputBloqueo(false);
    const RequestLC: ListarLimiteCreditoRequest = <ListarLimiteCreditoRequest>{}
    RequestLC.pintENTC_Codigo = 0
    RequestLC.psinTIPE_Codigo = this.codigoEntidad;
    this.dataTableLimiteCredito = []
    this.mantcomercial.ListarLimiteCredito(RequestLC).subscribe(response => {
      if (response.datos.status === 200) { this.dataTableLimiteCredito = response.datos.result }
    })
  }

  listadoEdit(entcCodigo) {
    const RequestCB: ListarCuentasBancariasRequest = <ListarCuentasBancariasRequest>{}
    RequestCB.pintENTC_Codigo = entcCodigo
    this.dataTableCuentasBancarias = []
    this.mantcomercial.ListarCuentasBancarias(RequestCB).subscribe(response => {
      if (response.datos.status === 200) { this.dataTableCuentasBancarias = response.datos.result }
    })
    const RequestLC: ListarLimiteCreditoRequest = <ListarLimiteCreditoRequest>{}
    RequestLC.pintENTC_Codigo = entcCodigo
    RequestLC.psinTIPE_Codigo = this.codigoEntidad;
    this.dataTableLimiteCredito = []
    this.mantcomercial.ListarLimiteCredito(RequestLC).subscribe(response => {
      if (response.datos.status === 200) {
        this.dataTableLimiteCredito = response.datos.result.map(r => {
          return {
            ...r,
            enlI_FecInicio: new Date(r.enlI_FecInicio),
            enlI_FecVencimiento: new Date(r.enlI_FecVencimiento)
          }
        })
      }
    })
    const RequestAU: ListarAuditoriaRequest = <ListarAuditoriaRequest>{}
    RequestAU.pintENTC_Codigo = entcCodigo
    this.dataTableAuditoria = []
    this.mantcomercial.ListarAuditoria(RequestAU).subscribe(response => {
      if (response.datos.status === 200) { this.dataTableAuditoria = response.datos.result }
    })
    const RequestAR: ListarArchivoEntidadRequest = <ListarArchivoEntidadRequest>{}
    RequestAR.ENAR_Codigo = 0
    RequestAR.ENTC_Codigo = entcCodigo
    this.uploadedFiles = []
    this.mantcomercial.ListarArchivosEntidad(RequestAR).subscribe(response => {
      if (response.datos.status === 200) {
        this.dataTableArchivos = response.datos.result
        this.uploadedFiles = this.dataTableArchivos.map(r => ({
          codigo: r.enaR_Codigo, tipotran: 'U', image: null, usuario: r.audI_UsrCrea, fecha: r.audI_FecCrea, nombre: r.enaR_NombreArchivo, url: r.enaR_Archivo
        }))
      }
    })
    const RequestDO: ConsultarDireccionEntidadRequest = <ConsultarDireccionEntidadRequest>{}
    RequestDO.pintENTC_Codigo = entcCodigo
    this.dataTableDireccion = []
    this.mantcomercial.ConsultarDireccionEntidad(RequestDO).subscribe(response => {
      if (response.datos.status === 200) {
        this.dataTableDireccion = response.datos.result
        this.dataTableDireccion.forEach(row => {
          if (row && row.dirE_Codigo === 1) {
            this.groupPoppupDG.get('direccion')?.setValue(row.dirE_Direccion);
            const pai = this.listPais.find(r => r.codigo.toUpperCase() === row.tipO_CodPais.toUpperCase())?.codigo
            this.groupPoppupDG.get('pais')?.setValue(pai);
            const partes = row.ubiG_Codigo?.split(".");
            const departamento = partes?.[0] ?? null;
            const provincia = partes?.[0] && partes?.[1] ? `${partes[0]}.${partes[1]}` : null;
            const distrito = row.ubiG_Codigo ?? null;
            this.onPaisSeleccionado(pai, 'INI')
            this.groupPoppupDG.get('departamento')?.setValue(departamento);
            this.onDepartamentoSeleccionado(departamento, 'INI')
            this.groupPoppupDG.get('provincia')?.setValue(provincia);
            this.onprovinciaSeleccionada(provincia, 'INI')
            this.groupPoppupDG.get('distrito')?.setValue(distrito);
          }
        });
      }
    })
  }

  cargarInputBloqueo(event) {
    if (event === true) {
      this.groupPoppupB.get('usuariobloqueo').setValue(this.nomUsuario)
      this.groupPoppupB.get('fechabloqueoo').setValue(new Date())
      this.groupPoppupB.get('usuariobloqueo').enable();
      this.groupPoppupB.get('fechabloqueoo').enable();
    } else {
      this.groupPoppupB.get('usuariobloqueo').setValue(null)
      this.groupPoppupB.get('fechabloqueoo').setValue(null)
      this.groupPoppupB.get('usuariobloqueo').disable();
      this.groupPoppupB.get('fechabloqueoo').disable();
    }
  }
  prueba: boolean = true
  correoface: string
  telfijo: string
  telmovil: string
  web: string
  row: ListarEntidades[] = []
  editEntidad(value, row: any) {
    this.listaDatosEntidad = row;
    this.estadoEditar = true;
    this.prueba = false
    this.visiblebtn = false
    this.visible = true
    this.dataTableCuentasBancarias = []
    this.dataTableLimiteCredito = []
    this.dataTableAuditoria = []
    this.dataTableDireccion = []
    this.dataTableArchivos = []
    this.uploadedFiles = []
    this.dataTableServicios = []
    this.groupPoppupDG.reset()
    this.groupPoppupD.reset()
    this.groupPoppupB.reset()
    this.groupPoppupE.reset()
    this.groupPoppupDG.get('tipopersona').setValue("J")
    if (row) {
      //DATOS GENERALES
      this.entcCod = row.entC_Codigo
      this.row = row
      this.listadoEdit(row.entC_Codigo)
      if (row.entC_Codigo) { this.groupPoppupDG.get('codigo').setValue(row.entC_Codigo) }
      if (row.entC_Activo) { this.groupPoppupDG.get('activo').setValue(row.entC_Activo) }
      if (row.entC_TipEnt) { this.groupPoppupDG.get('tipopersona').setValue(row.entC_TipEnt) }
      if (row.tipO_CodTDI) {
        const td = this.ListaTodosTipoDoc.find(r => r.codigo.toUpperCase() === row.tipO_CodTDI.toUpperCase())?.codigo
        this.groupPoppupDG.get('tipodocumento').setValue(td)
      }
      if (row.entC_DocIden) { this.groupPoppupDG.get('numerodocumento').setValue(row.entC_DocIden) }
      if (row.entC_RazonSocial) { this.groupPoppupDG.get('razonsocial').setValue(row.entC_RazonSocial) }
      if (row.entC_NomComercial) { this.groupPoppupDG.get('razoncomercial').setValue(row.entC_NomComercial) }
      if (row.nombreGerente) { this.groupPoppupDG.get('nomgerente').setValue(row.nombreGerente) }
      if (row.fechaNacimiento) { this.groupPoppupDG.get('fechanacimientog').setValue(new Date(row.fechaNacimiento)) }
      if (row.fechaAniversario) { this.groupPoppupDG.get('fechaAniversariog').setValue(new Date(row.fechaAniversario)) }
      if (row.entC_ApePat) { this.groupPoppupDG.get('apellidopaterno').setValue(row.entC_ApePat) }
      if (row.entC_ApeMat) { this.groupPoppupDG.get('apellidomaterno').setValue(row.entC_ApeMat) }
      if (row.entC_Nombres) { this.groupPoppupDG.get('nombres').setValue(row.entC_Nombres) }
      if (row.entC_Sexo) { this.groupPoppupDG.get('sexo').setValue(row.entC_Sexo) }
      if (row.entC_Area) { this.groupPoppupDG.get('area').setValue(row.entC_Area) }
      if (row.entC_Cargo) { this.groupPoppupDG.get('cargo').setValue(row.entC_Cargo) }
      if (row.entC_FecNac) { this.groupPoppupDG.get('fechanacimiento').setValue(new Date(row.entC_FecNac)) }
      if (row.entC_FecIng) { this.groupPoppupDG.get('fechaingreso').setValue(new Date(row.entC_FecIng)) }
      if (row.entC_EMail) { this.groupPoppupDG.get('correo').setValue(row.entC_EMail) }
      if (row.entC_NombreContacto) { this.groupPoppupDG.get('contactonombre').setValue(row.entC_NombreContacto) }
      if (row.entC_ApellidoContacto) { this.groupPoppupDG.get('contactoapellidos').setValue(row.entC_ApellidoContacto) }
      if (row.entC_CorreoContactoExpo) { this.groupPoppupDG.get('correoexport').setValue(row.entC_CorreoContactoExpo) }
      if (row.entC_FechaCredito) { this.groupPoppupDG.get('fechacredito').setValue(new Date(row.entC_FechaCredito)) }
      if (row.entC_DiasCredito) { this.groupPoppupDG.get('diascreditos').setValue(row.entC_DiasCredito) }
      if (row.entC_Obser) { this.groupPoppupDG.get('observaciones').setValue(row.entC_Obser) }
      if (row.entC_Domiciliado) { this.groupPoppupDG.get('nodomiciliado').setValue(row.entC_Domiciliado) }
      if (row.entC_VIP) { this.groupPoppupDG.get('vip').setValue(row.entC_VIP) }
      if (row.entC_ServicioLogistico) { this.groupPoppupDG.get('serviciologistico').setValue(row.entC_ServicioLogistico) }
      if (row.entC_Prospecto) { this.groupPoppupDG.get('prospecto').setValue(row.entC_Prospecto) }
      if (row.tipO_CodSEG) {
        const ts = this.ListarTodosSegmento.find(r => r.codigo.toUpperCase() === row.tipO_CodSEG.toUpperCase())?.codigo
        this.groupPoppupDG.get('segmento').setValue(ts)
      }
      if (row.entC_EMail2) { this.groupPoppupDG.get('correo_otros_traficos').setValue(row.entC_EMail2) }
      if (row.entC_EmailReceptorFE) { this.groupPoppupDG.get('correo_facturacion').setValue(row.entC_EmailReceptorFE) }
      if (row.entC_Telef2) { this.groupPoppupDG.get('telefono_movil').setValue(row.entC_Telef2) }
      if (row.entC_Telef1) { this.groupPoppupDG.get('telefono_fijo').setValue(row.entC_Telef1) }
      if (row.entC_Web) { this.groupPoppupDG.get('web').setValue(row.entC_Web) }
      if (row.entC_ToOrder) { this.groupPoppupDG.get('to_order').setValue(row.entC_ToOrder) }

      //SERVICIOS
      this.dataTableServicios = row['listadoserviciosentidad'];
      this.dataTableAuditoriaServicios = row['listadoauditoriaserviciosentidad'];
      this.dataTableRelacionados = row['listadoasociados'];
      // RELACIONADOS 
      if (row.tipE_Codigo) { this.groupPoppupE.get('tipoentidad').setValue(row.tipE_Codigo.toString()) }
      if (row.entC_DocIden) { this.groupPoppupE.get('numdocumento').setValue(row.entC_DocIden) }
      if (row.entC_RazonSocial) { this.groupPoppupE.get('razonsocial').setValue(row.entC_RazonSocial) }

      //OTROS DATOS
      if (row.entC_EmailFinanzas) { this.groupPoppupD.get('correofinanzas').setValue(row.entC_EmailFinanzas) }
      if (row.entC_InterbancarioSol) { this.groupPoppupD.get('ctaintersoles').setValue(row.entC_InterbancarioSol) }
      if (row.entC_InterbancarioDol) { this.groupPoppupD.get('ctainterdolares').setValue(row.entC_InterbancarioDol) }
      if (row.entC_CuentaDetraccion) { this.groupPoppupD.get('ctadetracciones').setValue(row.entC_CuentaDetraccion) }
      if (row.entC_ProvAsumeDetraccion) { this.groupPoppupD.get('asumedetraccion').setValue(row.entC_ProvAsumeDetraccion) }

      if (row.entC_Mandato) { this.groupPoppupD.get('esMandato').setValue(row.entC_Mandato) }
      if (row.entC_OtrosTraficos) { this.groupPoppupD.get('esOtrosTraficos').setValue(row.entC_OtrosTraficos) }
      if (row.entC_SLI) { this.groupPoppupD.get('esSli').setValue(row.entC_SLI) }
      if (row.entC_Exportacion) { this.groupPoppupD.get('esExportaciones').setValue(row.entC_Exportacion) }
      this.groupPoppupD.get('esMandato').disable();
      this.groupPoppupD.get('esOtrosTraficos').disable();
      this.groupPoppupD.get('esSli').disable();
      this.groupPoppupD.get('esExportaciones').disable();

      //BLOQUEO
      if (row.entC_BloqueoFinanzasProveedor) {
        this.groupPoppupB.get('bloqueado').setValue(row.entC_BloqueoFinanzasProveedor);
        this.cargarInputBloqueo(row.entC_BloqueoFinanzasProveedor);
      }
      if (row.entC_UsrBloqueoProveedor) { this.groupPoppupB.get('usuariobloqueo').setValue(row.entC_UsrBloqueoProveedor) }
      if (row.entC_FecBloqueoProveedor) { this.groupPoppupB.get('fechabloqueoo').setValue(new Date(row.entC_FecBloqueoProveedor)) }
      if (row.entC_ObsBloqueoProveedor) { this.groupPoppupB.get('comentariobloqueo').setValue(row.entC_ObsBloqueoProveedor) }
    }
  }
  uploadedFiles: any[] = [];
  onUpload(event) {
    if (event.files.length > 0) {
      for (let file of event.files) {
        const reader = new FileReader();
        reader.onload = (e) => {
          const base64Data = (e.target.result as string).split(',')[1];
          const req = {
            items: [{
              codigo: 0,
              tipotran: 'I',
              image: URL.createObjectURL(file),
              usuario: this.nomUsuario,
              fecha: this.util.formatearfecha(new Date(), 'dd-mm-yyyy'),
              nombre: file.name,
              url: base64Data
            }]
          }

          this.uploadedFiles.push({
            codigo: req.items[0].codigo,
            tipotran: req.items[0].tipotran,
            image: req.items[0].image,
            usuario: req.items[0].usuario,
            fecha: req.items[0].fecha,
            nombre: req.items[0].nombre,
            url: req.items[0].url
          });

          this.uploadedFiles = [...this.uploadedFiles]
        }
        reader.readAsDataURL(file);
      }
    }
  }

  obtenerIconoTipoArchivo(nombreArchivo: string): string {
    const extension = nombreArchivo.split('.').pop()?.toLowerCase();
    switch (extension) {
      case 'pdf':
        return '../../../../../assets/iconos/pdf.svg';
      case 'doc':
        return '../../../../../assets/iconos/documento.svg'
      case 'docx':
        return '../../../../../assets/iconos/word.svg'
      case 'jpg':
        return '../../../../../assets/iconos/jpg.svg'
      case 'jpeg':
      case 'png':
        return 'assets/icons/image-icon.svg';
      case 'xls':
        return '../../../../../assets/iconos/excel.svg'
      case 'xlsx':
        return '../../../../../assets/iconos/excel.svg'
      default:
        return 'assets/icons/default-icon.svg';
    }
  }

  downloadArchivo(value, row: any) {
    if (!row.url) {
      console.error('No hay archivo disponible para descargar.');
      return;
    }
    const extension = row.nombre.split('.').pop();
    const mimeType = this.getMimeType(extension);
    const fileName = `${row.nombre}.${extension}`;

    const byteCharacters = atob(row.url);
    const byteNumbers = new Array(byteCharacters.length);

    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: mimeType });
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();

    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  }

  getMimeType(extension: string): string {
    const mimeTypes: { [key: string]: string } = {
      'png': 'image/png',
      'jpg': 'image/jpeg',
      'jpeg': 'image/jpeg',
      'gif': 'image/gif',
      'pdf': 'application/pdf',
      'txt': 'text/plain',
      'doc': 'application/msword',
      'docx': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      'xls': 'application/vnd.ms-excel',
      'xlsx': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'zip': 'application/zip',
    };

    return mimeTypes[extension.toLowerCase()] || 'application/octet-stream';
  }

  deleteArchivo(row) {
    if (row) { row.tipotran = 'D'; }
  }

  verHistorial(value, row: any) {
    const Request: ListarHistorialRequest = <ListarHistorialRequest>{}
    Request.pintENTC_Codigo = this.entcCod
    Request.psinTIPE_Codigo = this.codigoEntidad;
    Request.pchrTIPO_TabMND = row.tipO_TabMND
    Request.pchrTIPO_CodMND = row.tipO_CodMND
    this.dataTableHistorial = []
    this.mantcomercial.ListarHistorialEntidad(Request).subscribe(response => {
      if (response.datos.status === 200) { this.dataTableHistorial = response.datos.result }
    })
  }
  ListaTranEntidad: TablaEntidadBloqueo[] = []
  ListaTranDirecEntidad: TablaDireccionEntidad[] = []
  async TransaccionEntidad(accion, row) {
    const tnsValida = await this.validarTransaccion();
    const emailValido = await this.validarEmail();
    const direccionValida = await this.validarDirecciones();
    if ((tnsValida == false || emailValido == false || direccionValida == false) && accion !== 'D') { return; }

    row = this.listaDatosEntidad
    const values = this.groupPoppupDG.value
    const valuesdatos = this.groupPoppupD.value
    const valuesbloqueo = this.groupPoppupB.value
    const RequestTrans: TransaccionEntidadBloqueoRequest = <TransaccionEntidadBloqueoRequest>{}
    RequestTrans.tablaDireccionEntidad = []
    const items = <TablaDireccionEntidad>{}
    items.ENTC_Codigo = this.entcCod || 0
    if (accion === 'I') {
      items.DIRE_Codigo = 0
    } else { items.DIRE_Codigo = 1 }
    items.DIRE_Direccion = values.direccion
    items.DIRE_Facturar = true
    items.DIRE_Referencia = null
    items.DIRE_Activo = true
    items.UBIG_Codigo = values.distrito
    items.TIPO_TabPais = 'PAI'
    items.TIPO_CodPais = values.pais
    items.AUDI_UsrCrea = this.nomUsuario
    items.AUDI_UsrMod = this.nomUsuario
    if (accion === 'I') {
      items.tipotran = 'I';
    } else if (accion === 'U') {
      if (values.direccion) {
        const direccionEnBD = this.dataTableDireccion.some(row => row && row.dirE_Codigo === 1);
        if (!direccionEnBD) {
          items.tipotran = 'I';
        } else {
          items.tipotran = 'U';
        }
      } else {
        items.tipotran = 'D';
      }
    }
    RequestTrans.tablaDireccionEntidad.push(items)
    RequestTrans.tablaEntidadBloqueo = []
    const itement = <TablaEntidadBloqueo>{}
    itement.ENTC_Codigo = this.entcCod || 0
    itement.TIPO_TabTDI = 'TDI'
    itement.TIPO_CodTDI = values.tipodocumento
    itement.ENTC_TipEnt = values.tipopersona
    itement.ENTC_DocIden = values.numerodocumento
    itement.ENTC_Domiciliado = values.nodomiciliado == null ? false : values.nodomiciliado
    itement.ENTC_Nombres = values.nombres
    itement.ENTC_ApePat = values.apellidopaterno
    itement.ENTC_ApeMat = values.apellidomaterno
    if (values.apellidopaterno && values.nombres) {
      itement.ENTC_NomCompleto = `${itement.ENTC_ApePat || ''} ${itement.ENTC_ApeMat || ''} ${itement.ENTC_Nombres || ''}`.trim();
    } else if (values.razoncomercial) {
      itement.ENTC_NomCompleto = values.razoncomercial;
    } else if (values.razonsocial) {
      itement.ENTC_NomCompleto = values.razonsocial;
    } else { itement.ENTC_NomCompleto = null }
    itement.ENTC_NomComercial = values.razoncomercial
    itement.ENTC_RazonSocial = values.razonsocial
    itement.ENTC_Activo = values.activo || false
    itement.ENTC_FecNac = values.fechanacimiento
    itement.ENTC_FecIng = values.fechaingreso
    itement.ENTC_VIP = values.vip == null ? false : values.vip
    itement.ENTC_Notas = this.row['entC_Notas'] || null
    itement.ENTC_Sexo = values.sexo
    itement.ENTC_EMail = values.correo
    itement.ENTC_Web = values.web
    itement.ENTC_Propio = this.row['entC_Propio'] || false
    itement.ENTC_Telef1 = values.telefono_fijo ?? null
    itement.ENTC_Telef2 = values.telefono_movil ?? null
    itement.ENTC_Telef3 = null
    itement.ENTC_Telef4 = null
    itement.ENTC_Beneficiario = this.row['entC_Beneficiario'] || null
    itement.ENTC_Area = values.area
    itement.ENTC_Cargo = values.cargo
    itement.USER_CodUsr = this.row['useR_CodUser'] || null
    itement.TIPO_TabPai = 'PAI'
    itement.TIPO_CodPai = values.pais
    itement.TIPO_TabHol = this.row['tipO_TabHol'] || null
    itement.TIPO_CodHol = this.row['tipO_CodHol'] || null
    itement.CONS_CodTFT = this.row['conS_CodTFT'] || null
    itement.CONS_TabTFT = this.row['conS_TabTFT'] || null
    itement.TIPO_TabCiu = this.row['tipO_TabCiu'] || null
    itement.TIPO_CodCiu = this.row['tipO_CodCiu'] || null
    itement.ENTC_Prospecto = values.prospecto || false
    itement.TIPO_TabDTM = this.row['tipO_TabDTM'] || null
    itement.TIPO_CodDTM = this.row['tipO_CodDTM'] || null
    itement.ENTC_ValRebate = this.row['entC_ValRebate'] || null
    itement.TIPO_TabMnd = this.row['tipO_TabMnd'] || null
    itement.TIPO_CodMnd = this.row['tipO_TabMnd'] || null
    itement.ENTC_ValTarja = this.row['entC_ValTarja'] || null
    itement.ENTC_DiasCredito = values.diascreditos
    itement.ENTC_FechaCredito = values.fechacredito
    itement.ENTC_Tarja = this.row['entC_Tarja'] || false
    itement.ENTC_CodAduana = this.row['entC_CodAduana'] || null
    itement.CONS_CodCre = this.row['conS_CodCre'] || null
    itement.CONS_TabCre = this.row['conS_CodCre'] || null
    itement.ENTC_EMail2 = values.correo_otros_traficos ?? null
    itement.ENTC_Obser = values.observaciones
    itement.ENTC_InterbancarioSol = valuesdatos.ctaintersoles
    itement.ENTC_InterbancarioDol = valuesdatos.ctainterdolares
    itement.ENTC_CuentaDetraccion = valuesdatos.ctadetracciones
    itement.ENTC_ServicioLogistico = values.serviciologistico ?? false
    itement.ENTC_OcultarShipper = this.row['entC_OcultarShipper'] || false
    itement.ENTC_ObsFinanzasCliente = this.row['entC_ObsFinanzasCliente'] || null
    itement.ENTC_BloqueoFinanzasCliente = this.row['entC_BloqueoFinanzasCliente'] || false
    itement.ENTC_UsrBloqueoCliente = this.row['entC_UsrBloqueoCliente'] || null
    itement.ENTC_FecBloqueoCliente = this.row['entC_FecBloqueoCliente'] || null
    itement.ENTC_EmailFinanzas = values.correofinanzas
    itement.ENTC_ObsBloqueoCliente = this.row['entC_ObsBloqueoCliente'] || null
    itement.ENTC_OtrosTraficos = valuesdatos.esOtrosTraficos ?? false
    itement.ENTC_Mandato = valuesdatos.esMandato ?? false
    itement.ENTC_SLI = valuesdatos.esSli ?? false
    itement.ENTC_Exportacion = valuesdatos.esExportaciones ?? false
    itement.ENTC_UsrBloqueoProveedor = valuesbloqueo.usuariobloqueo
    itement.ENTC_FecBloqueoProveedor = valuesbloqueo.fechabloqueoo
    itement.ENTC_BloqueoFinanzasProveedor = valuesbloqueo.bloqueado || false
    itement.ENTC_ObsFinanzasProveedor = this.row['entC_ObsFinanzasProveedor'] || null
    itement.ENTC_ObsBloqueoProveedor = valuesbloqueo.comentariobloqueo
    itement.ENTC_ProvAsumeDetraccion = valuesdatos.asumedetraccion || false
    itement.ENTC_ToOrder = values.to_order ?? false
    itement.AUDI_UsrCrea = this.nomUsuario
    itement.AUDI_UsrMod = this.nomUsuario
    itement.ENTC_EmailReceptorFE = values.correo_facturacion
    itement.TIPO_CodSEG = values.segmento ?? null
    itement.ENTC_NombreContacto = values.contactonombre
    itement.ENTC_ApellidoContacto = values.contactoapellidos
    itement.ENTC_CorreoContactoExpo = values.correoexport
    itement.nombreGerente = values.nomgerente
    itement.fechaNacimiento = values.fechanacimientog
    itement.fechaAniversario = values.fechaAniversariog
    itement.ENTC_Siglas = this.row['entc_siglas'] || null

    RequestTrans.tablaEntidadBloqueo.push(itement)
    RequestTrans.TIPE_Codigo = this.codigoEntidad;
    RequestTrans.DIRE_Facturar = true
    RequestTrans.ENTC_Codigo = row.entC_Codigo != null ? row.entC_Codigo : values['codigo']
    RequestTrans.operacion = accion

    RequestTrans.tablaserviciosentidad = [];
    RequestTrans.tabladetalleservicio = [];
    RequestTrans.tablazonatransporte = [];
    RequestTrans.tablatipocarga = [];

    this.dataTableCuentasBancarias = this.dataTableCuentasBancarias.map(item => ({
      tipotran: item.ESTADO_OBJ || 'U',
      ENTC_Codigo: this.entcCod,
      TIPO_TabBCO: 'BCO',
      TIPO_CodBCO: item.tipO_CodBCO ? item.tipO_CodBCO : item.tipO_BCO?.value,
      tipO_BCO: item.tipO_BCO?.label,
      ENCB_TipoCuenta: item.encB_TipoCuenta ? item.encB_TipoCuenta : item.tipoCuenta?.value,
      tipoCuenta: item.tipoCuenta?.label || item.encB_TipoCuenta,
      ENCB_NroCuentaSol: item.encB_NroCuentaSol,
      ENCB_NroCuentaDol: item.encB_NroCuentaDol,
      AUDI_UsrCrea: this.nomUsuario,
      AUDI_UsrMod: this.nomUsuario
    }));

    RequestTrans.tablacuentasbancarias = this.dataTableCuentasBancarias

    this.InsertLimCredito = this.dataTableLimiteCredito.map(item => ({
      ENTC_Codigo: this.entcCod,
      TIPE_Codigo: 2,
      ENLI_Tipos: "PRO",
      ENLI_Codigo: item.enlI_Codigo,
      ENLI_Monto: item.enlI_Monto || 0,
      ENLI_DiasDuracion: values.diascreditos,
      ENLI_Fecha: values.fechacredito,
      ENLI_Notas: item.enlI_Notas,
      ENLI_FecInicio: new Date(item.enlI_FecInicio) || null,
      ENlI_FecVencimiento: new Date(item.enlI_FecVencimiento) || null,
      ENLI_FormaPago: item.enlI_FormaPagoDescripcion?.value,
      TIPO_TabMND: 'MND',
      TIPO_CodMND: item.tipO_MND?.value,
      AUDI_UsrCrea: this.nomUsuario,
      AUDI_UsrMod: this.nomUsuario,
      ENLI_TipoFecVencimiento: null,
      ENLI_CliAutEmiCheqDiferidos: false,
      ENLI_CliConCredLibre: false,
      tipotran: accion
    }))

    RequestTrans.tablalimitecredito = this.InsertLimCredito

    this.InsertArchivos = this.uploadedFiles.map(item => ({
      ENAR_Codigo: item.codigo,
      ENTC_Codigo: this.entcCod,
      ENAR_Archivo: item.url,
      AUDI_UsrCrea: item.usuario,
      ENAR_NombreArchivo: item.nombre,
      ENAR_Extension: '.' + item.nombre.split('.').pop(),
      ID_OUT: 0,
      tipotran: item.tipotran
    }))

    RequestTrans.tablaarchivosentidad = this.InsertArchivos

    RequestTrans.tablaserviciosentidad = []
    this.dataTableServicios?.forEach((r, i) => {
      const items: TablaEntidadServicios = <TablaEntidadServicios>{};
      items.eseR_Codigo = r.eseR_Codigo ?? r.key;
      items.serV_Codigo = Number(r['serV_Nombre']?.value ?? r['serV_Codigo'] ?? 0);
      items.eseR_Valor = r['eseR_Valor'] ?? null;
      items.eseR_Exonerado = r['eseR_Exonerado'] == "" ? false : r['eseR_Exonerado'];
      items.entC_Codigo = row.entC_Codigo;
      items.audI_UsrCrea = this.nomUsuario;
      items.eseR_Cantidad = r['eseR_Cantidad'] != "" ? r['eseR_Cantidad'] : 0;
      items.tipO_TabMnd = 'MND';
      items.tipO_CodMnd = r['tipO_DescMND']?.value ?? r['tipO_CodMnd'] ?? null;
      items.conS_TabBas = 'BAS';
      items.conS_CodBas = r['conS_DescBAS']?.value ?? r['conS_CodBas'] ?? null
      if (r['ESTADO_OBJ'] == 'I' || r['ESTADO_OBJ'] == 'U' || r['ESTADO_OBJ'] == 'D') {
        items.ESTADO_OBJ = r['ESTADO_OBJ'];
        RequestTrans.tablaserviciosentidad.push(items);
      }
    });

    RequestTrans.tablaEntidadRelacionados = [];
    this.dataTableRelacionados?.forEach((r, i) => {
      const items: TablaEntidadRelacionados = <TablaEntidadRelacionados>{};
      items.relA_Codigo = r['relA_Codigo'] ?? null;
      items.entC_CodPadre = this.entcCod ?? 0;
      items.entC_CodHijo = Number(r['entC_RazonSocial']?.value) ?? r['entC_CodHijo'] ?? r['entC_RazonSocial'];
      items.conS_TabRGM = r['conS_TabRGM'] ?? "RGM";
      items.conS_CodRGM = r['conS_RGM']?.value ?? r['conS_RGM'] ?? null;
      items.relA_Activo = r['relA_Activo'] == null ? true : r['relA_Activo'];
      items.audI_UsrCrea = this.nomUsuario;
      items.audI_UsrMod = this.nomUsuario;
      items.tipO_TabTRF = r['tipO_TabTRF'] ?? "TRF";
      items.tipO_CodTRF = r['tipO_TRF']?.value ?? r['tipO_CodTRF'] ?? r['tipO_TRF'];
      items.relA_Tipos = r['relA_TipoRelacion']?.key ?? r['relA_Tipos'] ?? null;
      items.relA_DepTemNegociaAgente = r['relA_DepTemNegociaAgente'] == null ? false : r['relA_DepTemNegociaAgente'];
      items.tipE_CodPadre = r['tipE_CodPadre'] ?? this.codigoEntidad;
      items.tipE_CodHijo = Number(r['tipE_Hijo']?.value) ?? r['tipE_CodHijo'] ?? r['tipE_Hijo'];
      items.relA_Observacion = r['relA_Observacion'] ?? null;
      items.ESTADO_OBJ = r['ESTADO_OBJ'];
      if (r['ESTADO_OBJ'] == 'I' || r['ESTADO_OBJ'] == 'U' || r['ESTADO_OBJ'] == 'D') {
        RequestTrans.tablaEntidadRelacionados.push(items);
      }
    });

    if (accion === 'D') {
      this.mantcomercial.TransaccionEntidadBloqueo(RequestTrans).subscribe(response => {
        if (response.datos.status === 200) {
          this.util.ShowMessage({ titulo: '', mensaje: 'Se eliminaron los datos correctamente.', tipo: 'ok' })
          const razonsocial = this.group.get('razonsocial').value;
          const numdocumento = this.group.get('numdocumento').value;
          if (razonsocial != null || razonsocial != '' || numdocumento != null || numdocumento != '') { this.search(); }
        }
      }, err => {
        this.messageService.add({ key: 'toast1', severity: 'error', summary: 'Error', detail: err?.error?.meta?.mensaje });
      })
    } else {
      this.mantcomercial.TransaccionEntidadBloqueo(RequestTrans).subscribe(response => {
        if (response.datos.status === 200) {
          this.util.ShowMessage({ titulo: '', mensaje: response?.meta?.mensaje, tipo: 'ok' })
          this.visible = false

          const razonsocial = this.group.get('razonsocial').value;
          const numdocumento = this.group.get('numdocumento').value;
          if (razonsocial != null || razonsocial != '' || numdocumento != null || numdocumento != '') { this.search(); }

          this.enviar_correo_facturacion(response.datos.entc_codigo);
        }
      }, err => {
        this.messageService.add({ key: 'toast1', severity: 'error', summary: 'Error', detail: err?.error?.meta?.mensaje });
      })
    }
  }

  exportExcel() {
    let nuevadata = []
    this.dataTable.forEach(row => {
      const {
        entC_Codigo,
        tipO_CodTDI,
        entC_DocIden,
        entC_RazonSocial,
        entC_Activo,
        entC_EMail,
        entC_EmailReceptorFE,
        entC_Telef1,
        entC_Telef2,
        entC_CodSAP_C,
        entC_CodSAP_P,
        entC_FecActSAP,
        audI_UsrCrea,
        audI_FecCrea,
        audI_UsrMod,
        audI_FecMod
      } = row;
      const newItem = {
        "CÓDIGO": entC_Codigo,
        "TIPO DOC. IDENTIDAD": tipO_CodTDI,
        "N.I.T": entC_DocIden,
        "NOMBRE": entC_RazonSocial,
        "ACTIVO": entC_Activo === true ? 'SI' : 'NO',
        "CORREO": entC_EMail,
        "CORREO FACTURA ELECTRÓNICA": entC_EmailReceptorFE,
        "TEL. FIJO": entC_Telef1,
        "TEL. MÓVIL": entC_Telef2,
        "CLIENTE SAP": entC_CodSAP_C,
        "PROVEEDOR SAP": entC_CodSAP_P,
        "SINCRONIZACIÓN SAP": this.util.formatearfecha(entC_FecActSAP, 'dd-mm-yyyy'),
        "CREADO POR": audI_UsrCrea,
        "FECHA CREA": this.util.formatearfecha(audI_FecCrea, 'dd-mm-yyyy'),
        "MODIFICADO POR": audI_UsrMod,
        "FECHA MOD.": this.util.formatearfecha(audI_FecMod, 'dd-mm-yyyy')
      };
      nuevadata.push(newItem);
    });

    const data = [
      {
        data: nuevadata, cabeceras: []
      }
    ]
    this.util.ExportarExcel(data, 'MANTENIMIENTO PROVEEDORES.xlsx')
  }

  salir() {
    this.visible = false
  }

  verNumDoc(event) {
    if (event.value === '002') {
      this.groupPoppupDG.get('tipopersona').setValue("N")
      this.visiblenumdoc = true
    }
    else if (event.value === '004') { this.visiblenumdoc = false } else { this.visiblenumdoc = true }
  }

  salirBandejaPrincipal() {
    const rutaComponente = '/mantenimiento-comercial';
    this.router.navigate([rutaComponente]);
  }

  sincronizarSAP(row) {
    this.funcionSincronizarSAP(row.row, 'C')
  }

  funcionSincronizarSAP(row: any, tipoSocio: string) {
    this.metadataTable[0].loading = true;
    const loadingScreen = this.util.showLoadingScreen({ message: "Sincronizando ..." });
    const Request: SincronizarEntidadSapRequest = <SincronizarEntidadSapRequest>{}
    Request.ENTC_Codigo = row.entC_Codigo
    Request.TIPE_Codigo = row.tipE_Codigo
    Request.TipoSocio = tipoSocio
    this.mantcomercial.SincronizarEntidadSAP(Request).subscribe(response => {
      if (response.datos.status === 200) {
        this.util.ShowMessage({ titulo: "Sincronización Exitosa", mensaje: response.meta.mensajeRespuesta, icono: "OK", tipo: "ok" });
        this.metadataTable[0].loading = false;
        this.search();
        loadingScreen.close();
      } else {
        this.util.ShowMessage({ titulo: "ERROR", mensaje: response.meta.mensajeRespuesta, icono: "pi pi-exclamation-triangle", tipo: "warning" });
        this.metadataTable[0].loading = false;
        loadingScreen.close();
      }
    }, err => {
      this.util.ShowMessage({ titulo: "ERROR", mensaje: err?.error?.meta?.mensaje, icono: "pi pi-exclamation-triangle", tipo: "warning" });
      loadingScreen.close();
      this.metadataTable[0].loading = false;
    })
  }

  InsertArchivos: any[] = []
  dataButtons = [
    { icon: 'pi pi-download', function: () => this.exportAuditoria() }
  ];
  exportAuditoria() {
    let nuevadata = []
    this.dataTableAuditoria.forEach(row => {
      const {
        operacion,
        direccionip,
        nombremaquina,
        nombreaplicacion,
        usuariosql,
        usuarioaplicacion,
        fechamodificacion,
        codigoentidad,
        docidentidad,
        codigodocidentidad,
        numdocidentidad,
        tipopersona,
        domiciliado,
        nombres,
        apellidopaterno,
        apellidomaterno,
        nombrecompleto,
        nombrecomercial,
        razonsocial,
        activo,
        fechanacimiento,
        fechaingreso,
        vip,
        notas,
        sexo,
        email,
        email2,
        web,
        propio,
        telefono1,
        telefono2,
        telefono3,
        telefono4,
        beneficiario,
        area,
        cargo,
        cuentausuario,
        pais,
        codigopais,
        holding,
        codigoholding,
        tipotarifa,
        codigotarifa,
        prospecto,
        rebate,
        moneda,
        codigomoneda,
        tipodeposito,
        codtipodeposito,
        tarja,
        realizatarja,
        diacredito,
        fechacredito,
        codigoaduana,
        observaciones,
        cuenintersoles,
        cueninterdolares,
        cuendetraccion,
        serviciologistico,
        ocultarshipper,
        obserfinanzas,
        otrostraficos,
        mandato,
        sli,
        exportacion,
        emailfinanzas,
        bloqueocliente,
        usubloqueacliente,
        fecbloqueocliente,
        obserbloqueocliente,
        bloqueoproveedor,
        usubloqueaproveedor,
        fecbloqueoproveedor,
        obserbloqueoproveedor,
        obserproveedor,
        asumedetraccion,
        usuariocrea,
        fechacrea,
        usuariomodifica,
        fechamodifica
      } = row;
      const newItem = {
        "Operación": operacion,
        "Dirección IP": direccionip,
        "Nombre Máquina": nombremaquina,
        "Nombre Apliación": nombreaplicacion,
        "Usuario SQL": usuariosql,
        "Usuario Aplicación": usuarioaplicacion,
        "Fecha Modificación": fechamodificacion || '',
        "Código Entidad": codigoentidad || '',
        "Doc. Identidad": docidentidad || '',
        "Código Doc. Identidad": codigodocidentidad || '',
        "Num. Doc. Identidad": numdocidentidad || '',
        "Tipo Persona": tipopersona || '',
        "Domiciliado": domiciliado === true ? 'SI' : 'NO',
        "Nombres": nombres || '',
        "Ape. Paterno": apellidopaterno || '',
        "Ape. Materno": apellidomaterno || '',
        "Nom. Completo": nombrecompleto || '',
        "Nom. Comercial": nombrecomercial || '',
        "Razón Social": razonsocial || '',
        "Activo": activo === true ? 'SI' : 'NO',
        "Fec. Nacimiento": fechanacimiento,
        "Fec. Ingreso": fechaingreso,
        "VIP": vip === true ? 'SI' : 'NO',
        "Notas": notas,
        "Sexo": sexo,
        "E-mail": email,
        "E-mail2": email2,
        "Web": web,
        "Propio": propio,
        "Teléfono 1": telefono1,
        "Teléfono 2": telefono2,
        "Teléfono 3": telefono3,
        "Teléfono 4": telefono4,
        "Beneficiario": beneficiario,
        "Área": area,
        "Cargo": cargo,
        "Cuenta Usuario": cuentausuario,
        "País": pais,
        "Cod. País": codigopais,
        "Holding": holding,
        "Cod. Holding": codigoholding,
        "Tipo Tarifa": tipotarifa,
        "Cod. Tarifa": codigotarifa,
        "Prospecto": prospecto === true ? 'SI' : 'NO',
        "Rebate": rebate,
        "Moneda": moneda,
        "Cod. Moneda": codigomoneda,
        "Tipo Depósito": tipodeposito,
        "Cod. Tipo Depósito": codtipodeposito,
        "Tarja": tarja,
        "Reaiza Tarja": realizatarja === true ? 'SI' : 'NO',
        "Día Crédito": diacredito,
        "Fec. Crédito": fechacredito,
        "Cod. Aduana": codigoaduana,
        "Observaciones": observaciones,
        "Cuen. Inter. Soles": cuenintersoles,
        "Cuen. Inter. Dólares": cueninterdolares,
        "Cuen. Detracción": cuendetraccion,
        "Servicio Logístico": serviciologistico === true ? 'SI' : 'NO',
        "Ocultar Shipper": ocultarshipper === true ? 'SI' : 'NO',
        "Obser. Finanzas": obserfinanzas,
        "Otros Tráficos": otrostraficos === true ? 'SI' : 'NO',
        "Mandato": mandato === true ? 'SI' : 'NO',
        "SLI": sli === true ? 'SI' : 'NO',
        "Exportación": exportacion === true ? 'SI' : 'NO',
        "E-mail Finanzas": emailfinanzas,
        "Bloqueo Cliente": bloqueocliente === true ? 'SI' : 'NO',
        "Usu. Bloquea Cliente": usubloqueacliente,
        "Fec. Bloqueo Cliente": fecbloqueocliente,
        "Obser. Bloqueo Cliente": obserbloqueocliente,
        "Bloqueo Proveedor": bloqueoproveedor === true ? 'SI' : 'NO',
        "Usu. Bloquea Proveedor": usubloqueaproveedor,
        "Fec. Bloqueo Proveedor": fecbloqueoproveedor,
        "Obser. Bloqueo Proveedor": obserbloqueoproveedor,
        "Obser. Proveedor": obserproveedor,
        "Asume Detracción": asumedetraccion,
        "Usuario Crea": usuariocrea,
        "Fec. Crea": fechacrea,
        "Usuario Modifica": usuariomodifica,
        "Fec. Modifica": fechamodifica
      };
      nuevadata.push(newItem);
    });

    const data = [
      {
        data: nuevadata, cabeceras: []
      }
    ]
    this.util.ExportarExcel(data, 'AUDITORÍA PROVEEDOR.xlsx')
  }

  async validarTransaccion(): Promise<boolean> {
    let esValido = true;
    let mensajeError = "";

    const group = this.groupPoppupDG;
    const get = (campo: string) => group.get(campo)?.value;

    let controles = {
      // ENTC_Codigo: { requerido: get("ENTC_Codigo") == null, mensaje: "Debe ingresar el campo ENTC_Codigo" },
      TIPO_CodTDI: { requerido: !get("tipodocumento"), mensaje: "Debe seleccionar el campo tipo documento" },
      ENTC_TipEnt: { requerido: !get("tipopersona"), mensaje: "Debe ingresar el campo Tipo de Persona" },
      ENTC_DocIden: { requerido: !get("numerodocumento"), mensaje: "Debe ingresar el campo número de documento" },
      // ENTC_Domiciliado: { requerido: get("nodomiciliado") == null, mensaje: "Debe ingresar el campo No Domiciliado" },
      // ENTC_VIP: { requerido: get("vip") == null, mensaje: "Debe ingresar el campo VIP" },
    };

    if (this.natural) {
      const ctlr = { ENTC_Sexo: { requerido: !get("sexo"), mensaje: "Debe ingresar el campo Sexo" } };
      controles = { ...controles, ...ctlr };
    }

    // Validar campos básicos
    for (let campo in controles) {
      if (controles[campo].requerido) {
        group.get(campo)?.setErrors({ required: true });
        mensajeError += `* ${controles[campo].mensaje}\n`;
        esValido = false;
      } else {
        group.get(campo)?.setErrors(null);
      }
    }

    // Validar según tipo de entidad
    const tipEnt = get("tipopersona");
    if (tipEnt === "J") {
      if (!get("razonsocial")) {
        group.get("razonsocial")?.setErrors({ required: true });
        mensajeError += "* Debe ingresar el campo razón social\n";
        esValido = false;
      } else {
        group.get("razonsocial")?.setErrors(null);
      }
    } else {
      if (!get("nombres")) {
        group.get("nombres")?.setErrors({ required: true });
        mensajeError += "* Debe ingresar el campo nombre\n";
        esValido = false;
      } else {
        group.get("nombres")?.setErrors(null);
      }
    }

    // Validar crédito
    const diasCredito = get("diascreditos");
    const fechaCredito = get("fechacredito");

    if (diasCredito && diasCredito > 0 && !fechaCredito) {
      group.get("fechacredito")?.setErrors({ required: true });
      mensajeError += "* Debe ingresar el campo fecha crédito\n";
      esValido = false;
    } else {
      group.get("fechacredito")?.setErrors(null);
    }

    if (!diasCredito && fechaCredito) {
      group.get("diascreditos")?.setErrors({ required: true });
      mensajeError += "* Debe ingresar el campo días crédito\n";
      esValido = false;
    } else {
      group.get("diascreditos")?.setErrors(null);
    }

    if (!esValido) {
      this.messageService.add({ key: 'toast1', severity: 'error', summary: 'Completar campos obligatorios', detail: mensajeError });
    }

    return esValido;
  }

  async validarEmail(): Promise<boolean> {
    let l_correcto = true;
    let l_email1OK = true;
    let l_email2OK = true;
    let l_email3OK = true;

    let mensajeError = '';
    const delimiter = ';';

    // Validación de ENTC_EMail
    const ENTC_EMail = this.groupPoppupDG.get('correo')?.value;
    mensajeError = '';
    if (ENTC_EMail) {
      const correos = ENTC_EMail.split(delimiter);
      for (const correo of correos) {
        if (correo.trim() && !this.isValidEmail(correo.trim())) {
          l_email1OK = false;
        }
      }
      if (!l_email1OK) {
        mensajeError = 'El Formato del Correo es Incorrecto\n';
      }
    }

    // Validación de ENTC_EMail2
    const correo_otros_traficos = this.groupPoppupDG.get('correo_otros_traficos')?.value;
    if (correo_otros_traficos) {
      const correos2 = correo_otros_traficos.split(delimiter);
      for (const correo of correos2) {
        if (correo.trim() && !this.isValidEmail(correo.trim())) {
          l_email2OK = false;
        }
      }
      if (!l_email2OK) {
        mensajeError += 'El Formato del Correo de Otros Tráficos es Incorrecto\n';
      }
    }

    // Validación de ENTC_EmailReceptorFE
    const ENTC_EmailReceptorFE = this.groupPoppupDG.get('correo_facturacion')?.value;
    if (ENTC_EmailReceptorFE) {
      const correos3 = ENTC_EmailReceptorFE.split(delimiter);
      for (const correo of correos3) {
        if (correo.trim() && !this.isValidEmail(correo.trim())) {
          l_email3OK = false;
        }
      }
      if (!l_email3OK) {
        mensajeError += 'El Formato del Correo de Facturación es Incorrecto\n';
      }
    }

    if (!l_email1OK || !l_email2OK || !l_email3OK) {
      l_correcto = false;
      this.messageService.add({ key: 'toast1', severity: 'error', summary: 'El Formato de alguno de los correos ingresados es incorrecto', detail: mensajeError });
    }

    return l_correcto;
  }


  isValidEmail(emailList: string): boolean {
    const trimmed = (emailList || '').trim();
    if (!trimmed) return false;
    const emails = trimmed
      .split(/[\s,;]+/)
      .map(e => e.trim())
      .filter(e => e.length > 0);

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
    return emails.every(e => emailRegex.test(e));
  }

  validarDirecciones(): boolean {
    let l_correcto = true;
    let l_direccionFiscal = true;
    let l_direccionComercial = true;
    let mensajeError = '';

    const DIRE_Direccion = this.groupPoppupDG.get('direccion')?.value;
    const pais = this.groupPoppupDG.get('pais')?.value;

    if (pais) {
      if (!DIRE_Direccion) {
        l_direccionFiscal = false;
      }
    }

    // if (this.groupPoppupDG.TIPO_TabPaisFiscal && this.groupPoppupDG.TIPO_CodPaisFiscal) {
    //   if (!DIRE_Direccion) {
    //     l_direccionFiscal = false;
    //   }
    // }

    // if (this.groupPoppupDG.TIPO_TabPaisComercial && this.groupPoppupDG.TIPO_CodPaisComercial) {
    //   if (!this.groupPoppupDG.DIRE_DireccionComercial) {
    //     l_direccionComercial = false;
    //   }
    // }

    if (!l_direccionFiscal || !l_direccionComercial) {
      l_correcto = false;
      this.messageService.clear();
      this.messageService.add({ key: 'toast1', severity: 'error', summary: 'Campos obligatorios', detail: 'Debe ingresar una Dirección para poder guardar el registro' });
    }

    return l_correcto;
  }

  exportarAuditoriaServicios() {
    let nuevadata = []
    this.dataTableAuditoriaServicios.forEach(row => {
      const {
        operacion, direccion_IP, nombre_Maquina, nombre_Aplicacion, usuario_SQL, usuario_Aplicacion,
        fecha_Modificacion, codigo_Interno, cod_Servicio, cod_Entidad, valor, exonerado, cantidad, moneda,
        cod_Moneda, base_Calculo, cod_Base_Calculo, usuario_Crea, fec_Crea, usuario_Modifica, fec_Modifica
      } = row;
      const newItem = {
        "OPERACIÓN": operacion,
        "DIRECCIÓN IP": direccion_IP,
        "NOMBRE MÁQUINA": nombre_Maquina,
        "NOMBRE APLICACIÓN": nombre_Aplicacion,
        "USUARIO SQL": usuario_SQL,
        "USUARIO APLICACIÓN": usuario_Aplicacion,
        "FECHA MODIFICACIÓN": this.util.formatearfecha(fecha_Modificacion, 'dd/mm/yyyy'),
        "CÓDIGO INTERNO": codigo_Interno,
        "COD SERVICIO": cod_Servicio,
        "COD ENTIDAD": cod_Entidad,
        "VALOR": valor,
        "EXONERADO": exonerado === true ? 'SI' : 'NO',
        "CANTIDAD": cantidad,
        "MONEDA": moneda,
        "COD MONEDA": cod_Moneda,
        "BASE CÁLCULO": base_Calculo,
        "COD BASE CÁLCULO": cod_Base_Calculo,
        "USUARIO CREA": usuario_Crea,
        "FEC CREA": this.util.formatearfecha(fec_Crea, 'dd/mm/yyyy'),
        "USUARIO MODIFICA": usuario_Modifica,
        "FECHA MODIFICA": this.util.formatearfecha(fec_Modifica, 'dd/mm/yyyy')
      };
      nuevadata.push(newItem);
    });

    const data = [
      {
        data: nuevadata, cabeceras: []
      }
    ]
    this.util.ExportarExcel(data, 'AUDITORIA SERVICIOS AGENTES.xlsx')
  }

  onEntidadChange(event: { field: string; event: any, index: any; rowdata: any }) {
    let value: string = String(event.event.value.value);
    const index = event.index;
    const valueArray = value.includes('|') ? value.split('|') : [value];

    // const actualizarDropdown = (field: string, lista: any[]) => {
    //   const fieldToUpdate = this.metadataTableRelacionados.find(m => m.field === field);
    //   if (fieldToUpdate) { fieldToUpdate.dropdown = [...lista]; }
    // };

    if (event.field === 'relA_TipoRelacion') {
      this.ListaFiltradaTipoEntidadDP = valueArray.length > 1
        ? this.ListaTipoEntidadDP.filter(item => valueArray.includes(item.value))
        : this.ListaTipoEntidadDP.filter(item => item.value === value);

      this.actualizarDpMtRelacionados('tipE_Hijo', this.ListaFiltradaTipoEntidadDP);
      this.enviarValorDTRelacionados(this.ListaFiltradaTipoEntidadDP[0], index, 'tipE_Hijo');

      this.ListaFiltradaNombreEntidadesDP = valueArray.includes('6') || valueArray.includes('7')
        ? this.ListaNombreEntidadesDP.filter(item => item.tipo === 'AGE')
        : this.ListaNombreEntidadesDP.filter(item => {
          const tipos = {
            '15': 'DepositoVacio',
            '14': 'DepositoTemp',
            '3': 'EJEC',
            '4': 'CUS',
            '5': 'TRANSPORTISTA',
            '9': 'CONTACTO',
          };
          return item.tipo === tipos[value];
        });

      this.actualizarDpMtRelacionados('entC_RazonSocial', this.ListaFiltradaNombreEntidadesDP);
    }

    if (event.field === 'entC_RazonSocial') { // razon social/nombres
      if (value != null) {
        const Request: ListarEntidadesRequest = <ListarEntidadesRequest>{}
        Request.pintENTC_Codigo = Number(value);
        Request.pvchENTC_NomCompleto = null;
        Request.pvchTIPE_Codigo = event.rowdata.tipE_Hijo.value;
        Request.pvchENTC_DocIden = null;
        this.mantcomercial.ListarEntidades(Request).subscribe(response => {
          if (response.datos.status === 200) {
            const row = response.datos.result[0];
            this.enviarValorDTRelacionados(row.entC_EMail, index, 'entC_EMail');
            this.enviarValorDTRelacionados(row.entC_EmailReceptorFE, index, 'entC_EmailReceptorFE');
            this.enviarValorDTRelacionados(row.entC_Codigo, index, 'entC_CodHijo');
            this.enviarValorDTRelacionados(row.entC_DocIden, index, 'entC_DocIden');
          }
        })
      } else {
        this.enviarValorDTRelacionados(null, index, 'entC_EMail');
        this.enviarValorDTRelacionados(null, index, 'entC_EmailReceptorFE');
        this.enviarValorDTRelacionados(null, index, 'entC_CodHijo');
        this.enviarValorDTRelacionados(null, index, 'entC_DocIden');
      }
    }

  }

  async onServiciosChange(event: { field: string; event: any; index: any; rowdata: any }) {
    const index = event.index;
    let valorDP: string = String(event.event.value.value);
    const fieldCambiado = event.field;
    let nuevoValor;
    const rowdata = event.rowdata;
    if (fieldCambiado == "serV_Nombre") { // servicio
      if (valorDP != null) {
        const request = <consultarServiciosRequest>{}
        request.serv_codigo = Number(valorDP);
        this.mantcomercial.obtenerServiciosDetallado(request).subscribe((response) => {
          if (response.datos.status === 200) {
            const row = response.datos.result[0];
            let via = null;
            if (row.cons_codvia != null) {
              via = { label: row.cons_descvia, value: row.cons_codvia };
            }
            let regimen = null;
            if (row.cons_codrgm != null) {
              regimen = { label: row.cons_descrgm, value: row.cons_codrgm };
            }
            let lineaNegocio = null;
            if (row.cons_codlng != null) {
              lineaNegocio = { label: row.cons_desclng, value: row.cons_codlng };
            }
            this.enviarValorDTServicios(via, index, 'conS_DescVIA');
            this.enviarValorDTServicios(regimen, index, 'conS_DescRGM');
            this.enviarValorDTServicios(lineaNegocio, index, 'conS_DescLNG');
          }
        });

      }
    }
  }

  enviarValorDTServicios(value: any, index: any, field: string) {
    const nuevoValor = value;
    const eventToEmit = { field, event: { value: nuevoValor }, index };
    this.onDpChangeTblServicios.emit(eventToEmit);
  }

  enviarValorDTRelacionados(value: any, index: any, field: string) {
    const nuevoValor = value;
    const eventToEmit = { field, event: { value: nuevoValor }, index };
    this.onDpChangeTblRelacionados.emit(eventToEmit);
  }

  enviar_correo_facturacion(new_entc_codigo: string) {
    const informar_facturacion = this.groupPoppupDG.value.informar_facturacion;
    if (informar_facturacion == true) {

      const mailOrigen = this.correoUsuario;
      const mailTo = "facturacion@delfingroupco.com.pe";

      const request = <envioFinanzasNuevoClienteRequest>{};
      request.tbl_envioCorreo = [];
      request.formato = null;
      request.tbl_ruc = null;

      const requestc2 = <envioCorreosRequest>{};
      requestc2.destinatarios = 'ext_ichumpitaz@delfingroupco.com.pe';// mailTo
      requestc2.asunto_reunion = "CREACIÓN DE NUEVAS RAZONES SOCIALES TICKET N° [TICKET] [HBLS] [NOMBRE_CLIENTE_OV]";
      requestc2.tipo = null;
      requestc2.correoorigen = 'ext_mirus1@delfingroupco.com.pe';//mailOrigen;
      requestc2.copia = 'ext_mirus1@delfingroupco.com.pe'; // null
      requestc2.copiaoculta = null;
      requestc2.body = ""; // se obtiene en el backend
      requestc2.subject = requestc2.asunto_reunion;
      requestc2.fileContents = null;
      requestc2.fileNames = null;
      requestc2.bytesAtchivo = [];
      requestc2.nombrearchivos = [];
      requestc2.usuario = this.nomUsuario;
      request.tbl_envioCorreo.push(requestc2);

      const request_form = <formatoCorreoRequest>{};
      request_form.codigo = "001";
      request_form.nombre = "MantenimientoEntidades";
      request_form.sub_nombre = "CreacionNuevoClienteFacturacion";
      request.formato = request_form;

      const request_ruc = <registroNuevoRucRequest>{}
      request_ruc.tbl_ruc = [];
      request_ruc.usuario = this.nomUsuario;
      if (this.estadoEditar) {
        request_ruc.new_entc_codigo = this.groupPoppupDG.get('codigo').value;
      }
      else {
        request_ruc.new_entc_codigo = Number(new_entc_codigo);
      }

      const item_nuevo_ruc: itemsConfirmarRuc = { docv_codigo: 0, ruc: this.groupPoppupDG.get('numerodocumento').value }

      request_ruc.idticket = 0;
      request_ruc.tbl_ruc = [item_nuevo_ruc];

      request.tbl_ruc = request_ruc;

      this.mantcomercial.envioFinanzasNuevoCliente(request).subscribe(res => {
        if (res.datos.status === 200) {
          this.messageService.add({ key: 'toastGeneral', severity: 'success', summary: 'OK', detail: res?.meta?.mensaje });
        }
      }, err => {
        this.messageService.add({ key: 'toastGeneral', severity: 'error', summary: 'Error al informar a facturación', detail: err?.error?.meta?.mensaje });
      })

    }
  }

  multiEmailTrimmedValidator(control: AbstractControl): ValidationErrors | null {
    const value = (control.value || '').trim();
    if (!value) return null;
    const emails = value
      .split(/[\s,;]+/)
      .map(email => email.trim())
      .filter(email => email.length > 0);
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
    const allValid = emails.every(email => emailRegex.test(email));
    return allValid ? null : { email: true };
  }

  @ViewChild('dtEntidadRef') dtEntidad!: DatatableComponent;
  actualizarDpMtRelacionados = (field: string, lista: any[]) => {
    const fieldToUpdate = this.metadataTableRelacionados.find(m => m.field === field);
    if (fieldToUpdate) { fieldToUpdate.dropdown = lista; }
    const metadataItem = this.dtEntidad.metadata.find(m => m.field === field);
    if (metadataItem) {
      metadataItem.dropdown = [...lista];
    }
    this.cdr.detectChanges();
  };

  eliminar(row: any) {
    this.util.MessageDialog({
      titulo: 'Confirmación', mensaje: "¿Seguro que desea eliminar la entidad?", icono: "pi pi-exclamation-triangle", tipo: "warning",
      textoBtn: { textoBtnOpcion1: "Sí", textoBtnOpcion2: "No", },
      pregunta: { onAccept: () => { this.TransaccionEntidad('D', row); }, onReject: () => { return; } }
    })
    return;
  }
}
